export default __webpack_public_path__ + "static/media/Mini anima.dd179526.jpg";